module.exports = __webpack_public_path__ + "static/media/tester.852b6735.svg";